import { del, get, post, put } from "../../helpers/api_helper"

export const postMaterialRequest = data => {
  return !data?.id
    ? post(`material-request/create`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    : post(`material-request/edit/${data?.id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
}
export const postMaterialRequestFinance = data => {
  return !data?.id
    ? post(`material-requests`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    : post(`material-requests/update/${data?.id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
}

export const searchMaterialRequest = data => {
  return get(`material-requests/search?${data?.params}`)
}

export const searchMaterialRequestFinance = data => {
  return get(`material-requests/search?${data?.params}`)
}
export const fetchRequest = data => {
  return get(`material-request/fetch/${data}`)
}
export const fetchMRRequest = (id, locationId) => {
  return get(
    `material-requests/${id}${locationId ? `?location_id=${locationId}` : ""}`
  )
}
export const fetchRequestPOvoucher = data => {
  return get(`material-requests/${data}`)
}

export const materiarRequestProductlist = data => {
  return get(`/material-request/productlist/${data}`)
}
export const poProductlist = data => {
  return get(`/purchase-oreder/productlist/${data}`)
}

export const updateSupplierStatus = data => {
  return get(`suppliers/updatestatus/${data}`)
}

export const tradeDocDownload = data => {
  return get(`suppliers-trade_download/${data.id}`, {
    responseType: "blob",
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", `trade`)
    document.body.appendChild(link)
    link.click()
  })
}
export const downloadmr = (id, fileName) => {
  return get(`/material-request/pdf-statement/${id}`, {
    // params: { ...filter },
    responseType: "blob", // important
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", fileName)
    document.body.appendChild(link)
    link.click()
  })
}

// Action
export const updateAction = data => {
  return get(
    `material-request/updatestatus?material_request_id=${
      data?.materialReq
    }&status=${data?.status}${data?.remarks ? `&remarks=${data?.remarks}` : ""}`
  )
}
export const deleteSMR = data => {
  return del(`material-requests/delete/${data}`)
}

export const updateManPowerStatus = data => {
  return get(
    `manpower-request/update-status?manpower_requests_id=${data?.manPowerReq}&status=${data?.status}`
  )
}

// post RFQ

export const postRfq = data => {
  return post(`rfq/create`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export const searchRfq = data => {
  return get(`rfq/search?${data?.params}`)
}

// Action
export const updateRfqUpdate = data => {
  return put(`rfq/${data?.materialReq}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  })
}

// Action
export const updateRfqAction = data => {
  return put(`rfq/update-status/${data?.materialReq}`, {
    status: data?.status,
    description: data?.description,
    items: data?.items,
    remarks: data?.remarks,
  })
}

export const updateRfqReference = data => {
  return put(`rfq/${data?.id}?ref_code=${data?.ref_code}`)
}

export const fetchRfqReference = id => {
  return get(`rfq/${id}`)
}

export const searchMaterialRequesting = data => {
  return get(`material-requisitions/search?${data?.params}`)
}

export const postMaterialRequesting = data => {
  return !data?.id
    ? post(`material-requisitions/create`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    : post(`material-requisitions/edit/${data?.id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
}

export const fetchMRRequesting = data => {
  return get(`material-requisitions/fetch/${data}`)
}

// Action
export const updateMRRequesting = data => {
  return post(`material-requisitions/updatestatus/${data?.materialReq}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}
